import { Dialog } from "@headlessui/react";

import CTAButton from "components/CTA/Button";
import Loading from "components/Loading";

interface ReopenApplicationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  loading: boolean;
}

const ReopenApplicationDialog: React.FC<ReopenApplicationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  loading,
}) => {
  return (
    <Dialog open={open} onClose={onClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-lg scale-100 transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle opacity-100 shadow-xl transition-all">
          <Dialog.Title className="mb-2 font-semibold">
            Re-open Application
          </Dialog.Title>
          <div className="mb-4 border-b border-t border-gray-200 py-4">
            <p className="mb-2">
              Are you sure you want to Re-open this Application? This will
              trigger a new underwrite of the Application.
            </p>
            <p>
              If you only need to edit the Debt Consolidation form, please
              cancel and click Debt Consolidation Form.
            </p>
          </div>
          <div className="flex justify-end space-x-2">
            {loading ? (
              <Loading />
            ) : (
              <>
                <CTAButton small secondary label="Cancel" onClick={onClose} />
                <CTAButton
                  small
                  label="Re-open Application"
                  onClick={onConfirm}
                />
              </>
            )}
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default ReopenApplicationDialog;
